export const areasConstants = {
    GET_ZONES_BY_TYPE_REQUEST: 'GET_ZONES_BY_TYPE_REQUEST',
    GET_ZONES_BY_TYPE_SUCCESS: 'GET_ZONES_BY_TYPE_SUCCESS',
    GET_ZONES_BY_TYPE_FAILURE: 'GET_ZONES_BY_TYPE_FAILURE'
}

export default areasConstants;